import React from 'react';
import { Card } from '@/components/ui/card';
import { pct } from './GestionKpis';

const Th = ({ children, right }) => <th className={`px-3 py-2 text-[11px] font-semibold uppercase tracking-wide text-slate-500 ${right ? 'text-right' : 'text-left'}`}>{children}</th>;
const Td = ({ children, right, className = '' }) => <td className={`px-3 py-2 text-sm text-slate-700 ${right ? 'text-right tabular-nums' : ''} ${className}`}>{children}</td>;

export const GestionUsersTable = ({ users }) => (
  <Card className="border-slate-200 bg-white overflow-hidden" data-testid="gestion-users-table">
    <div className="px-5 pt-5 pb-3"><h4 className="font-semibold text-slate-900 text-sm">Gestiones por usuario</h4></div>
    {users.length === 0 ? <p className="text-sm text-slate-400 text-center pb-8">Nadie registró gestiones en el período.</p> : (
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-slate-50 border-y border-slate-200">
            <tr>
              <Th>Usuario</Th><Th right>Gestiones</Th><Th right>Llamadas</Th><Th right>WhatsApp</Th><Th right>SMS</Th><Th right>Email</Th><Th right>Notas</Th>
              <Th right>Positivas</Th><Th right>Tasa contacto</Th><Th right>Promesas</Th><Th right>Cumplidas</Th><Th right>Incumplidas</Th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {users.map((u) => (
              <tr key={u.user_email} className="hover:bg-slate-50/60" data-testid={`gestion-user-${u.user_email}`}>
                <Td><div className="font-medium text-slate-900">{u.user_name}</div><div className="text-[11px] text-slate-400">{u.user_email}</div></Td>
                <Td right className="font-semibold text-slate-900">{u.total}</Td>
                <Td right>{u.by_type.call}</Td><Td right>{u.by_type.whatsapp}</Td><Td right>{u.by_type.sms}</Td><Td right>{u.by_type.email}</Td><Td right>{u.by_type.note}</Td>
                <Td right>{u.positives}</Td>
                <Td right className="font-semibold text-teal-700">{u.attempts ? pct(u.contact_rate) : '—'}</Td>
                <Td right>{u.promises}</Td>
                <Td right className="text-emerald-700">{u.promises_kept}</Td>
                <Td right className="text-red-600">{u.promises_broken}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </Card>
);

export default GestionUsersTable;
